<template>
    <header
        v-if="dynamicComponents"
        :style="styles"
        class="o-header header"
    >
        <template 
            v-for="item in dynamicComponents"
        >
            <component
                :is="item"
                :key="item"
                :view="view"
            />
        </template>
    </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "OHeader",
    components: {
        ADate: () => import('../../atoms/a-date/a-date'),
        ALogo: () => import('../../atoms/a-logo/a-logo'),
        ABackButton: () => import('../../atoms/a-back-button'),
        AHomeButton: () => import('../../atoms/a-home-button'),
        MVersions: () => import('../../molecules/m-versions/m-versions'),
        AHeroTitle: () => import('../../atoms/a-hero-title/a-hero-title'),
        ACompanyInfo: () => import('../../atoms/a-company-info/a-company-info'),
        OLanguageSelector: () => import('../../organisms/o-language-selector/o-language-selector'),
        OTerminalsSelector: () => import('../../organisms/o-terminals-selector/o-terminals-selector'),
        OLanguageSelectorSK: () => import('../../organisms/o-language-selector-sk/o-language-selector-sk'),
        OLanguageSelectorNO: () => import('../../organisms/o-language-selector-no/o-language-selector-no')
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        dynamicComponents() {
            return Object.keys(this.getMapConfigProp(`views.${this.view}.header`)) || null;
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OHeader.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OHeader.params`) || {};
        },
        params() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OHeader.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OHeader.styles`) || {};
        },
        styles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        }
    }
}
</script>

<style lang="scss">
@import "o-header";
</style>
